/*
  Laskutustiedot ostoskorissa (snippets/invoice-fields.liquid).

  Kun asiakas valitsee "Tilaan yrityksenä tai oppilaitoksena laskulla", yritys, Y-tunnus,
  verkkolaskuosoite ja operaattori ovat pakollisia ennen kuin kassalle pääsee. Tiedot
  tallennetaan ostoskorin attribuutteina, jolloin ne näkyvät tilauksessa.

  Kaikki kuuntelijat ovat dokumentin tasolla, koska ostoskorin laatikko piirretään
  uudelleen jokaisen ostoskorin muutoksen jälkeen.
*/
(function () {
  'use strict';

  var ATTR = {
    flag: 'Laskutus',
    company: 'Laskutus: Yritys',
    vat: 'Laskutus: Y-tunnus',
    addr: 'Laskutus: Verkkolaskuosoite',
    op: 'Laskutus: Operaattori'
  };
  var FIELD_KEYS = [ATTR.company, ATTR.vat, ATTR.addr, ATTR.op];

  var css =
    '.sb-invoice{margin:1.2rem 0;padding:1.2rem 1.4rem;border:1px solid rgba(var(--color-foreground,18,18,18),.2);border-radius:4px;text-align:left}' +
    '.sb-invoice__toggle{display:flex;gap:.8rem;align-items:flex-start;cursor:pointer;font-weight:600;line-height:1.4}' +
    '.sb-invoice__toggle input{margin-top:.3rem;flex:none;width:1.8rem;height:1.8rem}' +
    '.sb-invoice__fields{margin-top:1rem}' +
    '.sb-invoice__fields[hidden],.sb-invoice__error[hidden]{display:none}' +
    '.sb-invoice__hint{margin:0 0 1rem;font-size:1.3rem;line-height:1.4;opacity:.8}' +
    '.sb-invoice__field{margin-bottom:1rem}' +
    '.sb-invoice__field label{display:block;margin-bottom:.4rem;font-size:1.3rem}' +
    '.sb-invoice__field input{width:100%;box-sizing:border-box;padding:.9rem 1rem;font:inherit;font-size:1.5rem;border:1px solid rgba(var(--color-foreground,18,18,18),.4);border-radius:4px;background:transparent;color:inherit}' +
    '.sb-invoice__field input[aria-invalid="true"]{border-color:#d32f2f;box-shadow:0 0 0 1px #d32f2f}' +
    '.sb-invoice__error{display:block;margin-top:.4rem;color:#d32f2f;font-size:1.3rem}';
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function saveAttributes(attributes) {
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function setExpressButtons(hidden) {
    document.documentElement.classList.toggle('sb-invoice-on', hidden);
    var id = 'sb-invoice-express-style';
    var existing = document.getElementById(id);
    if (hidden && !existing) {
      var s = document.createElement('style');
      s.id = id;
      s.textContent = '.additional-checkout-buttons{display:none!important}';
      document.head.appendChild(s);
    } else if (!hidden && existing) {
      existing.remove();
    }
  }

  /* Y-tunnus: 1234567-8, tarkistusnumero lasketaan painoilla 7,9,10,5,8,4,2 */
  function normalizeVat(v) {
    var s = String(v || '').replace(/\s/g, '').toUpperCase().replace(/^FI/, '');
    if (/^\d{8}$/.test(s)) s = s.slice(0, 7) + '-' + s.slice(7);
    return s;
  }

  function vatValid(v) {
    if (!/^\d{7}-\d$/.test(v)) return false;
    var w = [7, 9, 10, 5, 8, 4, 2];
    var sum = 0;
    for (var i = 0; i < 7; i++) sum += Number(v[i]) * w[i];
    var rem = sum % 11;
    if (rem === 1) return false;
    var check = rem === 0 ? 0 : 11 - rem;
    return check === Number(v[8]);
  }

  function normalizeAddr(v) {
    return String(v || '').replace(/\s/g, '').toUpperCase();
  }

  var VALIDATORS = {};
  VALIDATORS[ATTR.company] = function (v) {
    return v.trim().length >= 2 ? '' : 'Anna yrityksen tai oppilaitoksen nimi.';
  };
  VALIDATORS[ATTR.vat] = function (v) {
    if (!v) return 'Anna Y-tunnus.';
    return vatValid(normalizeVat(v)) ? '' : 'Tarkista Y-tunnus. Muoto on 1234567-8.';
  };
  VALIDATORS[ATTR.addr] = function (v) {
    if (!v) return 'Anna verkkolaskuosoite.';
    var a = normalizeAddr(v);
    return a.length >= 8 && a.length <= 35 && /^[A-Z0-9:._-]+$/.test(a)
      ? ''
      : 'Tarkista verkkolaskuosoite. Esimerkiksi 003712345678 tai IBAN-muotoinen osoite.';
  };
  VALIDATORS[ATTR.op] = function (v) {
    return v.trim().length >= 2 ? '' : 'Anna verkkolaskuoperaattori tai välittäjätunnus.';
  };

  function inputFor(root, key) {
    var all = root.querySelectorAll('[data-sb-inv]');
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-sb-inv') === key) return all[i];
    return null;
  }

  function showError(input, message) {
    var box = input.parentNode.querySelector('[data-sb-inv-error]');
    if (!box) return;
    if (message) {
      box.textContent = message;
      box.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      if (!box.id) box.id = input.id + '-err';
      input.setAttribute('aria-describedby', box.id);
    } else {
      box.textContent = '';
      box.hidden = true;
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }

  function normalizedValue(key, raw) {
    if (key === ATTR.vat) return normalizeVat(raw);
    if (key === ATTR.addr) return normalizeAddr(raw);
    return String(raw || '').trim();
  }

  function collect(root) {
    var out = {};
    FIELD_KEYS.forEach(function (key) {
      var el = inputFor(root, key);
      out[key] = el ? normalizedValue(key, el.value) : '';
    });
    return out;
  }

  /* Palauttaa ensimmäisen virheellisen kentän tai null */
  function validateAll(root) {
    var first = null;
    FIELD_KEYS.forEach(function (key) {
      var el = inputFor(root, key);
      if (!el) return;
      var msg = VALIDATORS[key](key === ATTR.vat || key === ATTR.addr ? normalizedValue(key, el.value) : el.value);
      showError(el, msg);
      if (msg && !first) first = el;
    });
    return first;
  }

  function rootOf(el) {
    return el.closest('[data-sb-invoice]');
  }

  function isOn(root) {
    var box = root && inputFor(root, 'on');
    return !!(box && box.checked);
  }

  var saveTimer;
  function saveDraft(root) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attrs = collect(root);
      attrs[ATTR.flag] = 'Kyllä';
      saveAttributes(attrs);
    }, 400);
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    var key = el.getAttribute('data-sb-inv');
    if (!key) return;
    var root = rootOf(el);
    if (!root) return;

    if (key === 'on') {
      var fields = root.querySelector('[data-sb-inv-fields]');
      if (fields) fields.hidden = !el.checked;
      setExpressButtons(el.checked);
      if (el.checked) {
        saveAttributes((function () {
          var a = {};
          a[ATTR.flag] = 'Kyllä';
          return a;
        })());
      } else {
        clearTimeout(saveTimer);
        var clear = {};
        clear[ATTR.flag] = '';
        FIELD_KEYS.forEach(function (k) {
          clear[k] = '';
          var f = inputFor(root, k);
          if (f) {
            f.value = '';
            showError(f, '');
          }
        });
        saveAttributes(clear);
      }
      return;
    }

    el.value = normalizedValue(key, el.value) || el.value.trim();
    if (VALIDATORS[key]) showError(el, VALIDATORS[key](el.value));
    saveDraft(root);
  });

  /* Enter ei saa lähettää ostoskorin lomaketta kesken täyttämisen */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.getAttribute && e.target.getAttribute('data-sb-inv') && e.target.type === 'text') {
      e.preventDefault();
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var button = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
      if (!button) return;
      var scope = button.closest('.drawer__footer, #main-cart-footer') || document;
      var root = scope.querySelector('[data-sb-invoice]');
      if (!root || !isOn(root)) return;

      if (button.getAttribute('data-sb-inv-ok') === '1') {
        button.removeAttribute('data-sb-inv-ok');
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var firstBad = validateAll(root);
      if (firstBad) {
        firstBad.focus();
        firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      var attrs = collect(root);
      attrs[ATTR.flag] = 'Kyllä';
      clearTimeout(saveTimer);
      button.disabled = true;
      saveAttributes(attrs)
        .catch(function () {})
        .then(function () {
          button.disabled = false;
          button.setAttribute('data-sb-inv-ok', '1');
          button.click();
        });
    },
    true
  );

  /* Alkutila: jos valinta on jo päällä, piilota pikamaksupainikkeet */
  function init() {
    var root = document.querySelector('[data-sb-invoice]');
    if (root && isOn(root)) setExpressButtons(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
